<div class="row row-sm">
    <div class="col-lg-12">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/DivisionMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <div *ngIf="submitButton">
                                <h3 class="main-content-label mb-0"><b>
                                    {{'header.division-data.table.Division'| translate}}
                                    </b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    {{'header.division-data.table.AddNewDivisionRecord' | translate}}
                                </p>
                            </div>
                            <div *ngIf="editButton">
                                <h3 class="main-content-label mb-0"><b>
                                    {{'header.division-data.table.Division'| translate}}</b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    {{'header.division-data.table.UpdateDivisionRecord' |
                                    translate}}
                                </p>
                            </div>
                            <div *ngIf="deleteButton">
                                <h3 class="main-content-label mb-0"><b>
                                    {{'header.division-data.table.Division'| translate}}</b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    {{'header.division-data.table.DeleteDivisionRecord' | translate}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">
                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="DivisionForm ">
                        <div class="col-lg-12 col-md-12">
                            <div class="row clearfix ">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width ">
                                                <mat-label>{{'header.division-data.table.CountryName' | translate}}</mat-label>
                                                <mat-select [disabled]="isreadonly" [disabled]="isreadonlydel"
                                                    onkeydown="return (event.keyCode!=13);" #select33
                                                    placeholder="CoFcCode" class="colorblack"
                                                    formControlName="CountryCode">
                                                    <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'CountryName'" [array]="CountryCodeList"
                                                        (filteredReturn)="filteredListCountryCode =$event"></mat-select-filter>
                                                    <mat-option onkeydown="return (event.keyCode!=13);"
                                                        *ngFor="let item of filteredListCountryCode"
                                                        [value]="item.CountryCode" (click)="fetchStateCode(item.CountryCode)">
                                                        {{item.CountryName}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DivisionForm.controls['CountryCode'].touched && DivisionForm.controls['CountryCode'].errors?.required">
                                                    {{'header.division-data.table.Mandatory' | translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width ">
                                                <mat-label>{{'header.division-data.table.StateName' | translate
                                                    }}</mat-label>
                                                <mat-select [disabled]="isreadonly" [disabled]="isreadonlydel"
                                                    onkeydown="return (event.keyCode!=13);" #select333
                                                    placeholder="StateCode" class="colorblack"
                                                    formControlName="StateCode">
                                                    <mat-select-filter *ngIf="select333.focused"
                                                        [placeholder]="'Filter'" [displayMember]="'StateName'"
                                                        [array]="StateCodeList"
                                                        (filteredReturn)="filteredListStateCode =$event"></mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredListStateCode"
                                                        [value]="item.StateCode">
                                                        {{item.StateName}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DivisionForm.controls['StateCode'].touched && DivisionForm.controls['StateCode'].errors?.required">
                                                    {{'header.division-data.table.Mandatory' | translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{'header.division-data.table.DivisionCode' |
                                                    translate }}
                                                </mat-label>
                                                <input appUppercase [readonly]="isreadonly" onkeydown="return (event.keyCode!=13);"
                                                    class="color" type="text" maxlength="5" [readonly]="isreadonlydel"
                                                    placeholder="Division Code" formControlName="DivisionCode" matInput
                                                    required>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DivisionForm.controls['DivisionCode'].touched && DivisionForm.controls['DivisionCode'].errors?.required">
                                                    {{'header.division-data.table.Mandatory' |
                                                    translate }}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DivisionForm.controls['DivisionCode'].touched && DivisionForm.controls['DivisionCode'].errors?.pattern">
                                                    {{'header.division-data.table.Invalid' | translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width ">
                                                <mat-label>
                                                    {{'header.division-data.table.DivisionName' |
                                                    translate }}
                                                </mat-label>
                                                <input appCamelcase [readonly]="isreadonlydel"
                                                    onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    maxlength="25" placeholder="Division Name"
                                                    formControlName="DivisionName" matInput required>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DivisionForm.controls['DivisionName'].touched && DivisionForm.controls['DivisionName'].errors?.required">
                                                    {{'header.division-data.table.Mandatory' | translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DivisionForm.controls['DivisionName'].touched && DivisionForm.controls['DivisionName'].errors?.pattern">
                                                    {{'header.division-data.table.Invalid' | translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row prpl">
                                    <div class="col-sm-12">

                                        <button id="Save" type="button" *ngIf="submitButton && DivCreate" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                        (click)="submit()">
                                        <span style="display: contents; align-items: center;">
                                            <img width="25%" src="../../assets/img/save.gif"
                                                style="margin-right: 5px;">
                                            {{'header.division-data.table.Save' | translate}}
                                        </span>
                                    </button>
                                    <button id="Update" type="button" *ngIf="editButton && DivUpdate" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                    (click)="update()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="25%" src="../../assets/img/edit1.gif"
                                            style="margin-right: 5px;">
                                        {{'header.division-data.table.Update' | translate}}
                                    </span>
                                </button>
                                <button id="Delete" type="button" *ngIf="deleteButton && DivDelete" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                (click)="openConformationModalBox()">
                                <span style="display: contents; align-items: center;">
                                    <img width="25%" src="../../assets/img/trash.gif"
                                        style="margin-right: 5px;">
                                    {{'header.division-data.table.Delete' | translate}}
                                </span>
                            </button>
                                        <button id="Back" type="button" [mat-dialog-close]="true"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1 ">
                                            <span style="display: contents; align-items: center;">
                                                <img width="25%" src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 5px ;">
                                                {{'header.division-data.table.Back' | translate}}
                                            </span>
                                        </button>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>